import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';
import Col from 'react-bootstrap/lib/Col';

import Tutorial from '../general/Tutorial';
import Icon from '../general/Icon';

function Breadcrumb ({ pageName, tutorialName }) {
    const classNames = classnames(
        'breadcrumb',
        'border--bottom',
        'text-primary',
        'text-weight--normal',
        'margin-bottom--sm'
    );

    return (
        <Col md={ 12 } className={ classNames }>
            <span className="margin-right--sm">{ pageName }</span>
            { tutorialName && <Tutorial name={ tutorialName }>
                <Icon icon="info" />
            </Tutorial> }
        </Col>
    );
}


Breadcrumb.propTypes = {
    pageName: PropTypes.string,
    tutorialName: PropTypes.string
};

Breadcrumb.defaultProps = {
    tutorialName: ''
};


export default Breadcrumb;



// WEBPACK FOOTER //
// ./src/components/account/Breadcrumb.js